module.exports = __webpack_public_path__ + "img/homeLc.968590de.png";